
import '../../src/Css/bootstrap.min.css';
import '../../src/App.css';
// import HomePage from './pages/index';
//موقتا صفحه اصلی گذاشته شد تا صفحه زیرسیستم طراحی شود
import HomePage from "../Pages/index";
import { useDispatch } from 'react-redux';
import Loader from 'react-loader-spinner';
import Menu from '../Components/Header/Menu';
import { useState, useEffect, Fragment } from 'react';
import PopupMenu from './Components/PopupMenu';
import SearchProduct from './pages/SearchProduct';
import ModalDialog from './Components/ModalDialog';
import SytemSettings from './pages/SystemSettings';
import AddEditProduct from './pages/AddEditProduct';
import SearchCustomer from './pages/SearchCustomer';
import MenuWide from '../Components/Header/MenuWide';
import AddEditCustomer from './pages/AddEditCustomer';
import ModalEnlargeImage from "./Common/ModalEnlargeImage";
import ModalAddEditProductGroup from './pages/ModalAddEditProductGroup';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import UserManagement from './pages/UserManagement';
import { getActiveSubsystems,  useIsMobileApp } from '../store/api/CommonFunctions';
import SearchCommands from '../Pages/SearchCommands';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import UserDashboard from '../Pages/UserDashboard';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchSentSMS from '../Pages/SearchSentSMS';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import AddEditPersonnel from './pages/AddEditPersonnel';
import SearchPersonnel from './pages/SearchPersonnel';

const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App(props) {
  const { setQAList, setModalAboutUs } = props;
  const dispatch = useDispatch();
  const isMobile = useIsMobileApp();
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [menuWidth, setMenuWidth] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());
    document.getElementById("CompanyName")?.setAttribute("systemname", "تنظیمات و اطلاعات پایه");
  }, []);
  return (
    <div className="App">
      <Router>
        <ModalDialog />
        <ModalEnlargeImage />
        {currentUser &&
          <Fragment>
            <PopupMenu />
            <div  style={{ position: "relative", height: "max-content", display: "flex", paddingRight:"12px", paddingLeft:"12px" }}>
              {isMobile ? <Menu menuName="BaseInfo"/>:
                <>
                  <label style={{ fontSize: "30px", cursor: "pointer", position: "relative"}} onClick={() => { setMenuWidth("250px") }}>&#9776;</label>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="BaseInfo" setQAList={setQAList} />
                </>}
            </div>
            <Switch>
              <Route path="/BaseInfo/SystemSettings"><SytemSettings /></Route>
              <Route path="/BaseInfo/AddEditCustomer/:id"><AddEditCustomer /></Route>
              <Route path="/BaseInfo/SearchCustomer"><SearchCustomer /></Route>
              <Route path="/BaseInfo/AddEditProductGroup"><ModalAddEditProductGroup /></Route>
              <Route path="/BaseInfo/AddEditProduct/:id"><AddEditProduct /></Route>
              <Route path="/BaseInfo/SearchProduct"><SearchProduct /></Route>
              <Route path="/BaseInfo/UserManagement"><UserManagement /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/BaseInfo/AddEditPersonnel/:id"><AddEditPersonnel/></Route>
              <Route path="/BaseInfo/SearchPersonnel"><SearchPersonnel/></Route>
              <Route path="/BaseInfo"><HomePage /></Route>

            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}
      </Router>
    </div>
  );
}

export default App;
